<template>
  <div class="create-employe">
    <el-backtop target=".create-employe"></el-backtop>
    <header-top showBack></header-top>
    <!-- :headerText="headerText" -->
    <div class="header-title show-back">{{ headerText }}</div>
    <div class="basic-info">
      <el-form
        label-position="left"
        label-width="10rem"
        ref="companyStoreForm"
        :rules="companyStoreRules"
        :model="companyStore"
      >
        <!-- 基本信息 -->
        <div class="basic-item">
          <div class="basic-item-title">基本信息</div>
          <div class="basic-item-main">
            <!-- 左 -->
            <div class="main-item">
              <el-form-item label="分销商门店封面" class="auto-height">
                <div class="basic-head">
                  <div class="basic-head-item">
                    <img
                      src="@/assets/image/default-img.png"
                      alt="default"
                      class="default-img"
                      v-if="!photoUrl"
                    />
                    <el-image
                      v-else
                      class="basic-head-img"
                      :src="photoUrl"
                      fit="cover"
                    ></el-image>
                    <el-upload
                      action="https://jsonplaceholder.typicode.com/posts/"
                      :on-change="uploadChange"
                      list-type="picture"
                      :before-upload="beforeAvatarUpload"
                      :show-file-list="false"
                      :http-request="getFile"
                      accept=".jpg, .png, .jpeg"
                    >
                      <el-button class="upload-btn"
                        >{{ photoUrl ? "更换" : "上传" }}封面</el-button
                      >
                    </el-upload>
                  </div>
                  <div class="form-tip">
                    注意：建议上传格式为jpg/jpeg/png且大小不超过5MB的图片
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="关联组织" prop="organizationId">
                <el-select
                  v-model="companyStore.organizationId"
                  filterable
                  remote
                  placeholder="请输入组织关键词"
                  :remote-method="getOrganization"
                  :loading="getOrgLoading"
                >
                  <el-option
                    v-for="item in orgList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="选择负责人"
                prop="userId"
              >
                <el-select
                  v-model="companyStore.userId"
                  filterable
                  remote
                  placeholder="请输入负责人关键词"
                  @focus="getUser('')"
                  :remote-method="getUser"
                  :loading="getUserLoading"
                >
                  <el-option
                    v-for="item in userList"
                    :key="item.id"
                    :label="item.name || '匿名'"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="选择分销商" prop="companyId">
                <el-select
                  v-model="companyStore.companyId"
                  filterable
                  remote
                  placeholder="请输入分销商关键词"
                  @focus="getCompany('')"
                  :remote-method="getCompany"
                  :loading="getCompanyLoading"
                >
                  <el-option
                    v-for="item in companyList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="分销商门店名称" prop="name">
                <el-input
                  v-model="companyStore.name"
                  placeholder="请输入分销商门店名称"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="分销商门店类型" prop="type">
                <el-select
                  v-model="companyStore.type"
                  clearable
                  placeholder="请选择分销商门店类型"
                >
                  <el-option
                    v-for="item in companyTypeOptions"
                    :key="item.value"
                    :label="item.value"
                    :value="item.key"
                  ></el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="分销商门店状态" prop="status">
                <el-select
                  v-model="companyStore.status"
                  clearable
                  placeholder="请选择分销商门店状态"
                >
                  <el-option
                    v-for="item in companyStatusOptions"
                    :key="item.value"
                    :label="item.value"
                    :value="item.key"
                  ></el-option>
                </el-select>
              </el-form-item> -->
            </div>
            <!-- 右 -->
            <div class="main-item basic-item-right main-item-flex">
              <el-form-item label="是否主店" prop="isMaster">
                <el-radio-group v-model="companyStore.isMaster">
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false">否</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item label="分销商门店租金" prop="rent">
                <el-input
                  v-model="companyStore.rent"
                  placeholder="请输入分销商门店租金"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="分销商门店面积" prop="area">
                <el-input
                  v-model="companyStore.area"
                  placeholder="请输入分销商门店面积"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="分销商门店退出方式" prop="dropWay">
                <el-radio-group v-model="companyStore.dropWay">
                  <el-radio
                    v-for="(item, index) in companyDropWayOptions"
                    :key="index"
                    :label="item.option"
                    >{{ item.option }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>
              <el-form-item label="分销商门店退出时间" prop="dropTime">
                <el-date-picker
                  value-format="yyyy-MM-dd"
                  v-model="companyStore.dropTime"
                  type="date"
                  placeholder="请选择分销商门店退出时间"
                  clearable
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="歇业开始时间" prop="closeStartTime">
                <el-date-picker
                  value-format="yyyy-MM-dd"
                  v-model="companyStore.closeStartTime"
                  type="date"
                  placeholder="请选择歇业开始时间"
                  clearable
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="歇业结束时间" prop="closeEndTime">
                <el-date-picker
                  value-format="yyyy-MM-dd"
                  v-model="companyStore.closeEndTime"
                  type="date"
                  placeholder="请选择歇业结束时间"
                  clearable
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="联系电话" prop="phoneNumber">
                <el-input
                  v-model="companyStore.phoneNumber"
                  placeholder="请输入联系电话"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="电子邮箱" prop="email">
                <el-input
                  v-model="companyStore.email"
                  placeholder="请输入电子邮箱"
                  clearable
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </div>
        <!-- 详细信息 -->
        <div class="basic-item">
          <div class="basic-item-title">详细信息</div>
          <div class="basic-item-main">
            <!-- 左 -->
            <div class="main-item">
              <el-form-item label="营业执照名称" prop="businessName">
                <el-input
                  v-model="companyStore.businessName"
                  placeholder="请输入营业执照名称"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="营业执照号码" prop="businessLicense">
                <el-input
                  v-model="companyStore.businessLicense"
                  placeholder="请输入营业执照号码"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="加盟合同编号">
                <el-input
                  v-model="companyStore.contractNumber"
                  placeholder="请输入加盟合同编号"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="加盟合同生效时间" prop="contractStartTime">
                <el-date-picker
                  value-format="yyyy-MM-dd"
                  v-model="companyStore.contractStartTime"
                  type="date"
                  placeholder="请选择加盟合同生效时间"
                  clearable
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="加盟合同结束时间" prop="contractEndTime">
                <el-date-picker
                  value-format="yyyy-MM-dd"
                  v-model="companyStore.contractEndTime"
                  type="date"
                  placeholder="请选择加盟合同结束时间"
                  clearable
                >
                </el-date-picker>
              </el-form-item>
            </div>
            <!-- 右 -->
            <div class="main-item basic-item-right main-item-flex">
              <el-form-item label="最晚开业核准日期" prop="lastAllowWorkTime">
                <el-date-picker
                  value-format="yyyy-MM-dd"
                  v-model="companyStore.lastAllowWorkTime"
                  type="date"
                  placeholder="请选择最晚开业核准日期"
                  clearable
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="实际开业核准日期" prop="actualAllowWorkTime">
                <el-date-picker
                  value-format="yyyy-MM-dd"
                  v-model="companyStore.actualAllowWorkTime"
                  type="date"
                  placeholder="请选择实际开业核准日期"
                  clearable
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="工商注册地址">
                <el-input
                  v-model="companyStore.registerAddress"
                  placeholder="请输入工商注册地址"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="实际经营地址">
                <el-input
                  v-model="companyStore.currentAddress"
                  placeholder="请输入实际经营地址"
                  clearable
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </div>
        <!-- 缴费信息 -->
        <div class="basic-item">
          <div class="basic-item-title">缴费信息</div>
          <div class="basic-item-main">
            <!-- 左 -->
            <div class="main-item">
              <el-form-item label="保证金" prop="deposit">
                <el-input
                  v-model="companyStore.deposit"
                  placeholder="请输入保证金"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="加盟费" prop="joinFee">
                <el-input
                  v-model="companyStore.joinFee"
                  placeholder="请输入加盟费"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="支付类型" prop="paymentType">
                <el-select
                  v-model="companyStore.paymentType"
                  clearable
                  placeholder="请选择分销商门店类型"
                >
                  <el-option
                    v-for="item in companyPayMentOptions"
                    :key="item.value"
                    :label="item.value"
                    :value="item.key"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="收费金额" prop="paymentMoney">
                <el-input
                  v-model="companyStore.paymentMoney"
                  placeholder="请输入收费金额"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="收费比例" prop="paymentRate">
                <el-input
                  v-model="companyStore.paymentRate"
                  placeholder="请输入收费比例"
                  clearable
                ></el-input>
              </el-form-item>
            </div>
            <!-- 右 -->
            <div class="main-item basic-item-right main-item-flex">
              <el-form-item label="特费缴费开始时间" prop="paymentStartTime">
                <el-date-picker
                  value-format="yyyy-MM-dd"
                  v-model="companyStore.paymentStartTime"
                  type="date"
                  placeholder="请选择特费缴费开始时间"
                  clearable
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="特费缴费结束时间" prop="paymentEndTime">
                <el-date-picker
                  value-format="yyyy-MM-dd"
                  v-model="companyStore.paymentEndTime"
                  type="date"
                  placeholder="请选择特费缴费结束时间"
                  clearable
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="收费保底费用" prop="leastPaymentMoney">
                <el-input
                  v-model="companyStore.leastPaymentMoney"
                  placeholder="请输入收费保底费用"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="收费政策描述" prop="paymentDescription">
                <el-input
                  type="textarea"
                  resize="none"
                  :rows="2"
                  placeholder="请输入收费政策描述"
                  v-model="companyStore.paymentDescription"
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </div>

        <div class="group-btn">
          <el-button
            type="primary"
            @click="createCompany('companyStoreForm')"
            :loading="submitLoading"
            >保存</el-button
          >
          <el-button @click="$router.go(-1)">取消</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import indexJs from './index.js';
export default {
  ...indexJs
}
</script>

<style lang="scss" scoped>
.create-employe {
  background-color: #f2f2f2;
  height: calc(100vh - 50px);
  overflow-y: scroll;

  // @media (max-width: 1440px) {
  //   .basic-info {
  //     margin: 20px;
  //   }

  //   .up-top {
  //     display: none;
  //   }
  // }

  // @media (min-width: 1440px) and (max-width: 1680px) {
  //   .basic-info {
  //     margin: 20px 70px;
  //   }

  //   .up-top {
  //     right: 5px;
  //     bottom: 5px;
  //   }
  // }

  // @media (min-width: 1680px) and (max-width: 1920px) {
  //   .basic-info {
  //     margin: 20px 120px;
  //   }
  // }

  // @media (min-width: 1920px) {
  //   .basic-info {
  //     margin: 20px 180px;
  //   }
  // }

  .basic-info {
    margin: 20px;
    padding: 20px;
    border-radius: $--border-radius-base;
    text-align: left;
    min-width: 960px;
    background-color: #fff;
    // box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);
    ::v-deep .el-date-editor {
      .el-input__inner {
        padding-left: 30px;
      }
      .el-icon-circle-close {
        right: 0;
      }
    }
    .basic-item {
      .post-symbol {
        color: #f56c6c;
      }

      .basic-item-title {
        margin-bottom: 20px;
        font-size: 14px;
        font-weight: bold;
        color: rgba(0, 0, 0, 1);
      }

      .add-position {
        margin-bottom: 10px;
      }

      .basic-item-main {
        margin-bottom: 25px;
        padding-bottom: 15px;
        display: flex;
        border-bottom: 1px solid #ddd;

        .main-item {
          width: 50%;

          .el-select,
          .el-input,
          .el-textarea {
            width: 330px;
          }

          .basic-head {
            .basic-head-item {
              display: flex;
              align-items: flex-end;
              margin-bottom: 8px;
              line-height: 0;

              .default-img,
              .basic-head-img {
                margin-right: 10px;
                width: 143px;
                height: 148px;
              }

              .upload-btn {
                border: 1px solid rgba(221, 221, 221, 1);
                width: 110px;
                height: 30px;
                font-size: 12px;
                font-weight: 400;
                color: rgba(0, 0, 0, 1);
              }
            }
          }

          .account-lock {
            display: inline-block;
            margin-right: 5px;
          }

          .lock-svg {
            margin-top: -2px;
          }

          .work-age {
            display: flex;
            width: 330px;

            .el-input {
              width: 50%;
              &:first-child {
                ::v-deep .el-input-group__append {
                  border-right-color: transparent;
                }
              }
            }
          }

          ::v-deep .el-form-item__content {
            .el-input-group {
              vertical-align: baseline;
            }
          }
        }

        .basic-item-right {
          padding-left: 50px;
        }
      }

      .el-table {
        margin-bottom: 25px;
        .table-empty {
          color: $--color-primary;
          cursor: pointer;
        }
        .grade-box {
          display: flex;
          align-items: center;

          .grade-main {
            margin-left: 9px;
            border: 1px solid $--color-primary;
            padding: 0 5px;

            font-size: 12px;
            font-weight: 400;
            line-height: 18px;

            color: $--color-primary;
          }
        }
      }
    }

    .group-btn {
      margin-top: -5px;
    }

    ::v-deep .employe-position {
      .el-dialog__header {
        padding: 25px 25px 20px 25px;
      }

      .el-dialog__body {
        padding: 0 25px;

        .el-input,
        .el-select,
        .el-textarea {
          width: 396px;
        }

        .vue-treeselect__input-container {
          height: 28px;
        }

        .vue-treeselect__menu {
          width: 350px;
        }
      }

      .el-dialog__footer {
        padding: 15px 25px 25px 25px;
      }
    }
  }
}
</style>